import React, { FunctionComponent } from 'react'
import { Modal, Button, Container, Row, Col, Card } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NewsAndUpdate from '../../../types/NewsUpdates'
import { formatUTCDate } from '../../../utils/stringTools'
import { getDomainName } from '../../../utils/envVariables'
import { Link } from 'react-router-dom'

interface Props {
  show: boolean;
  onClose: () => void;
  newsItem: NewsAndUpdate | null;
}

const NewsModal: FunctionComponent<Props> = (props) => {
  const { show, onClose, newsItem } = props
  const newsItemExists = newsItem !== null
  const domainName = getDomainName()
  let content
  if (newsItemExists) {
    if (newsItem) {
      content = newsItem.attachment
    }
  } else {
    content = ''
  }
  return (
    <Modal size="xl" show={show} onHide={onClose}>
      <Modal.Header closeButton id="modal-header">
        <FontAwesomeIcon icon={['fas', 'file-alt']} size="lg" className="modal-header-icon" />
        <Modal.Title id="modal-header-title">News Item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container style={{ backgroundColor: '#f2f2f2', paddingBottom: '2rem' }}>
          <Row style={{ padding: 20 }}>
            <Col xs={6}>
              <h4>{newsItem ? newsItem.title : ''}</h4>
              <div>Published: {formatUTCDate(newsItem ? newsItem.date : '')}</div>
            </Col>
            <Col xs={6}>
              <div style={{ float: 'right' }}>
                <div>Attachment:</div>
                {
                  content === '' || content === null
                    ? (<div>N/A</div>)
                    : (
                      <div>
                        <Link
                          to="route"
                          onClick={(event) => { event.preventDefault(); window.open(domainName+'/pdf/news/'+content.split('/')[content.split('/').length - 1]) }}
                        >
                          {content.split('/')[content.split('/').length - 1]}
                        </Link>
                      </div>
                    )
                }
              </div>
            </Col>
          </Row>
          <Card>
            <Card.Body>{newsItem?newsItem.content:''}</Card.Body>
          </Card>
        </Container>
        <Row>
          <Col xs={4} sm={4} md={4} lg={4}></Col>
          <Col xs={4} sm={4} md={4} lg={4}>
            <Button variant="outline-secondary" block onClick={onClose} style={{ marginTop: 15 }}>
                            Close
            </Button>
          </Col>
          <Col xs={4} sm={4} md={4} lg={4}></Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default NewsModal